import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/members")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "Members",
  }),
});
